import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { IndustryState, RootState } from './industry-types';

export const state: IndustryState = {
  industry: undefined,
  error: false,
};

const namespaced = true;

export const industry: Module<IndustryState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
